import React from 'react';
import {
  FireIcon,
  EMSIcon,
  PoliceIcon,
  AttentionTriangleIcon,
  TrainIcon,
} from '@rsos/assets/icons';
import { DISPATCH_REQUESTED, NEW } from '@rsos/constants/alertStatuses';
import { IconContainer } from './Alert.styles';

// starting from 4.20.0 going forward, Emergency types that are multiple words should now be properly captialized and spaced
export const mapIcon = (type, theme) => {
  const isTestAlertType = `${type}`.startsWith('test');
  // alert type is used for icon mapping. if a test alert, strip the `test` word to re-use same set of icons
  const sanitizedType = () => {
    if (isTestAlertType) {
      return `${type}`.replace('test ', '');
    } else {
      return type;
    }
  };
  const iconColor = theme.colors.background;
  const trainIconColor = isTestAlertType
    ? iconColor
    : theme.colors.trainIncidentAlert?.iconColor || iconColor;
  const getIconBgColor = () => {
    // for RSP if a test alert apply same bg color to all corresponding icons
    if (isTestAlertType) {
      return theme.colors.secondaryText;
    }
    const bg = {
      burglary: theme.colors.primaryBaseC2,
      co: theme.colors.heavyWarning,
      crash: theme.colors.primaryBaseC2,
      fire: theme.colors.heavyWarning,
      holdup: theme.colors.primaryBaseC2,
      medical: theme.colors.success,
      other: theme.colors.primaryBaseC2,
      'silent alarm': theme.colors.primaryBaseC2,
      'active assailant': theme.colors.lightDanger,
      'mobile panic': theme.colors.primaryBaseC2,
      'train derailment': theme.colors.trainIncidentAlert.iconBg,
    };
    return bg[type];
  };
  const icons = {
    burglary: (
      <IconContainer bg={getIconBgColor()}>
        <PoliceIcon width={15} height={14} color={iconColor} />
      </IconContainer>
    ),
    co: (
      <IconContainer bg={getIconBgColor()}>
        <FireIcon width={20} height={20} color={iconColor} />
      </IconContainer>
    ),
    crash: (
      <IconContainer bg={getIconBgColor()}>
        <PoliceIcon width={15} height={14} color={iconColor} />
      </IconContainer>
    ),
    fire: (
      <IconContainer bg={getIconBgColor()}>
        <FireIcon width={20} height={20} color={iconColor} />
      </IconContainer>
    ),
    holdup: (
      <IconContainer bg={getIconBgColor()}>
        <PoliceIcon width={15} height={14} color={iconColor} />
      </IconContainer>
    ),
    medical: (
      <IconContainer bg={getIconBgColor()}>
        <EMSIcon width={15} height={14} color={iconColor} />
      </IconContainer>
    ),
    other: (
      <IconContainer bg={getIconBgColor()}>
        <PoliceIcon color={iconColor} width={15} height={14} />
      </IconContainer>
    ),
    'silent alarm': (
      <IconContainer bg={getIconBgColor()}>
        <PoliceIcon color={iconColor} width={15} height={14} />
      </IconContainer>
    ),
    'active assailant': (
      <IconContainer bg={getIconBgColor()}>
        <AttentionTriangleIcon height={13} width={24} color={iconColor} />
      </IconContainer>
    ),
    'train derailment': (
      <IconContainer bg={getIconBgColor()}>
        <TrainIcon width={15} height={15} color={trainIconColor} />
      </IconContainer>
    ),
    'mobile panic': (
      <IconContainer bg={getIconBgColor()}>
        <PoliceIcon color={iconColor} width={15} height={14} />
      </IconContainer>
    ),
  };
  return icons[sanitizedType()];
};

/**
 * Introduced for multi-routing handles different scenarios for displaying alerts
 * @param {bool} isSupplementalOnly
 * @param {string} alertStatus
 * @param {string} whoTookAction
 * @returns displayed status
 */
export const displayAlertStatus = (
  isSupplementalOnly,
  alertStatus,
  whoTookAction,
) => {
  const isDispatchRequested = alertStatus === DISPATCH_REQUESTED;
  if (isSupplementalOnly) {
    return '';
  }
  if (isDispatchRequested) {
    return NEW;
  } else {
    return whoTookAction;
  }
};
